import React, { useState, useEffect, useRef, useContext } from "react";
import { ThemeContext } from "../../../../context/ThemeContext";
import { getData, postData, serverURL } from "../../../../services/Fetchnodeservices";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const EyeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const DeleteIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const HideIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const ShowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const XIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const UploadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const RefreshIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M23 4v6h-6" />
    <path d="M1 20v-6h6" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" />
    <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14" />
  </svg>
);

const ServiceIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M20 7h-3V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v3H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
    <path d="M9 4h6v3H9z" />
  </svg>
);

const LinkIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// ADD SERVICE DIALOG COMPONENT (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────
const AddServiceDialog = ({ onClose, onSave, editingService, theme }) => {
  const [formData, setFormData] = useState({
    title: editingService?.title || "",
    description: editingService?.description || "",
    button_name: editingService?.button_name || "",
    button_link: editingService?.button_link || "",
    status: editingService?.status === "1" || editingService?.status === 1 ? "Active" : "Hidden",
  });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  // Set pic preview when editing
  useEffect(() => {
    if (editingService?.pic) {
      const imgUrl = getImageUrl(editingService.pic);
      setImagePreview(imgUrl);
    }
  }, [editingService]);

  // Image URL function (preserved as-is for correct path)
  const getImageUrl = (picName) => {
    if (!picName || picName.trim() === "" || picName === "NULL" || picName === "null") {
      return null;
    }
    if (picName.startsWith('http')) {
      return picName;
    }
    let filename = picName;
    if (filename.includes('/')) {
      filename = filename.split('/').pop();
    }
    if (filename.includes('\\')) {
      filename = filename.split('\\').pop();
    }
    return `${serverURL}/uploadnew/upload/${filename}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (file) => {
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleImageChange(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      handleImageChange(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.title.trim()) {
      alert("Please enter service title");
      return;
    }
    
    setUploading(true);
    
    const submitFormData = new FormData();
    submitFormData.append("title", formData.title);
    submitFormData.append("description", formData.description || "");
    submitFormData.append("button_name", formData.button_name || "");
    submitFormData.append("button_link", formData.button_link || "");
    submitFormData.append("status", formData.status === "Active" ? "1" : "0");
    
    if (imageFile) {
      submitFormData.append("pic", imageFile);
    }
    
    if (editingService) {
      submitFormData.append("id", editingService.id);
    }
    
    await onSave(submitFormData, editingService);
    setUploading(false);
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 14px",
    background: theme.surfaceLighter,
    border: `1px solid ${theme.border}`,
    borderRadius: "12px",
    fontSize: "14px",
    color: theme.textPrimary,
    outline: "none",
    transition: "all 0.2s",
    boxSizing: "border-box",
    fontFamily: "inherit",
  };

  const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontSize: "12px",
    fontWeight: 600,
    color: theme.textSecondary,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        backdropFilter: "blur(8px)",
        animation: "fadeIn 0.2s ease-out",
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "90%",
          maxWidth: "600px",
          background: theme.surface,
          borderRadius: "20px",
          boxShadow: `0 25px 60px ${theme.primary}30`,
          overflow: "hidden",
          animation: "slideUp 0.3s ease-out",
          border: `1px solid ${theme.border}`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "18px 24px",
            borderBottom: `1px solid ${theme.border}`,
            background: theme.surfaceLighter,
          }}
        >
          <h3
            style={{
              fontSize: "20px",
              fontWeight: 700,
              color: theme.textPrimary,
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "8px",
                background: `${theme.primary}15`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: theme.primary,
              }}
            >
              {editingService ? <EditIcon /> : <PlusIcon />}
            </div>
            {editingService ? "Edit Service" : "Add Service"}
          </h3>
          <button
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: theme.textMuted,
              padding: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "8px",
              transition: "all 0.2s",
            }}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = `${theme.error || theme.danger}15`;
              e.currentTarget.style.color = theme.error || theme.danger;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "none";
              e.currentTarget.style.color = theme.textMuted;
            }}
          >
            <CloseIcon />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ padding: "24px", maxHeight: "65vh", overflowY: "auto" }}>
            {/* Title */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>
                Title <span style={{ color: theme.error || theme.danger }}>*</span>
              </label>
              <input
                type="text"
                name="title"
                style={inputStyle}
                placeholder="Enter service title"
                value={formData.title}
                onChange={handleChange}
                required
                autoFocus
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = theme.primary;
                  e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = theme.border;
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Description */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>
                Description
                <span style={{ color: theme.textMuted, fontWeight: 400, textTransform: "none", letterSpacing: "0", marginLeft: "6px" }}>
                  ({formData.description.length} chars)
                </span>
              </label>
              <textarea
                name="description"
                style={{ ...inputStyle, minHeight: "100px", resize: "vertical" }}
                placeholder="Enter service description"
                value={formData.description}
                onChange={handleChange}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = theme.primary;
                  e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = theme.border;
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Image Upload */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Image</label>
              <div
                style={{
                  border: `2px dashed ${dragActive ? theme.primary : theme.border}`,
                  borderRadius: "16px",
                  padding: "24px",
                  textAlign: "center",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  background: dragActive ? `${theme.primary}08` : theme.surfaceLighter,
                  marginTop: "8px",
                }}
                onClick={() => fileInputRef.current?.click()}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/png, image/jpeg, image/jpg, image/webp"
                  onChange={handleFileInput}
                  style={{ display: "none" }}
                />
                <div style={{ display: "flex", justifyContent: "center", marginBottom: "12px", color: theme.primary }}>
                  <UploadIcon />
                </div>
                <div style={{ fontSize: "14px", fontWeight: 600, color: theme.textPrimary, marginBottom: "6px" }}>
                  {imagePreview ? "Change Image" : "Click or drag image here"}
                </div>
                <div style={{ fontSize: "11px", color: theme.textMuted }}>
                  PNG, JPG, WebP up to 10MB
                </div>
                {imagePreview && (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    style={{
                      width: "100%",
                      maxHeight: "160px",
                      objectFit: "cover",
                      borderRadius: "12px",
                      marginTop: "16px",
                      border: `1px solid ${theme.border}`,
                    }}
                  />
                )}
              </div>
            </div>

            {/* Button Name & Link - Grid */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "20px" }}>
              <div>
                <label style={labelStyle}>Button Name</label>
                <input
                  type="text"
                  name="button_name"
                  style={inputStyle}
                  placeholder="e.g., Join Now"
                  value={formData.button_name}
                  onChange={handleChange}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = theme.primary;
                    e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = theme.border;
                    e.currentTarget.style.boxShadow = "none";
                  }}
                />
              </div>
              <div>
                <label style={labelStyle}>Button Link</label>
                <input
                  type="text"
                  name="button_link"
                  style={inputStyle}
                  placeholder="e.g., /path"
                  value={formData.button_link}
                  onChange={handleChange}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = theme.primary;
                    e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = theme.border;
                    e.currentTarget.style.boxShadow = "none";
                  }}
                />
              </div>
            </div>

            {/* Status - Card Style */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Status</label>
              <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
                <label
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: theme.textPrimary,
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: `1px solid ${formData.status === "Active" ? theme.success : theme.border}`,
                    background: formData.status === "Active" ? `${theme.success}15` : "transparent",
                    transition: "all 0.2s",
                    fontWeight: 500,
                  }}
                >
                  <input
                    type="radio"
                    name="status"
                    value="Active"
                    checked={formData.status === "Active"}
                    onChange={handleChange}
                    style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: theme.success }}
                  />
                  <ShowIcon /> Active
                </label>
                <label
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: theme.textPrimary,
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: `1px solid ${formData.status === "Hidden" ? theme.textMuted : theme.border}`,
                    background: formData.status === "Hidden" ? `${theme.textMuted}15` : "transparent",
                    transition: "all 0.2s",
                    fontWeight: 500,
                  }}
                >
                  <input
                    type="radio"
                    name="status"
                    value="Hidden"
                    checked={formData.status === "Hidden"}
                    onChange={handleChange}
                    style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: theme.textMuted }}
                  />
                  <HideIcon /> Hidden
                </label>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              padding: "16px 24px",
              borderTop: `1px solid ${theme.border}`,
              background: theme.surfaceLighter,
            }}
          >
            <button
              type="button"
              style={{
                padding: "10px 20px",
                background: "transparent",
                border: `1px solid ${theme.border}`,
                borderRadius: "10px",
                fontSize: "14px",
                fontWeight: 500,
                color: theme.textPrimary,
                cursor: "pointer",
                transition: "all 0.2s",
              }}
              onClick={onClose}
              onMouseEnter={(e) => (e.currentTarget.style.background = theme.surfaceHover || theme.surface)}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                padding: "10px 24px",
                background: uploading ? theme.textMuted : theme.primary,
                border: "none",
                borderRadius: "10px",
                fontSize: "14px",
                fontWeight: 600,
                color: "#fff",
                cursor: uploading ? "not-allowed" : "pointer",
                boxShadow: uploading ? "none" : `0 4px 12px ${theme.primary}40`,
                transition: "all 0.2s ease",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
              disabled={uploading}
              onMouseEnter={(e) => {
                if (!uploading) {
                  e.currentTarget.style.transform = "translateY(-1px)";
                  e.currentTarget.style.boxShadow = `0 6px 16px ${theme.primary}60`;
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = uploading ? "none" : `0 4px 12px ${theme.primary}40`;
              }}
            >
              {uploading ? "⏳ Saving..." : (editingService ? "Update Service" : "Save Service")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// SUB-COMPONENTS (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────

const StatusBadge = ({ status, theme }) => {
  const isActive = status === "1" || status === 1;
  const config = isActive
    ? { bg: `${theme.success}1a`, color: theme.success, text: "Active", dot: theme.success }
    : { bg: `${theme.textMuted}1a`, color: theme.textMuted, text: "Hidden", dot: theme.textMuted };
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        padding: "4px 10px",
        borderRadius: "20px",
        fontSize: "11px",
        fontWeight: 600,
        background: config.bg,
        color: config.color,
      }}
    >
      <span style={{ width: "5px", height: "5px", borderRadius: "50%", background: config.dot }} />
      {config.text}
    </span>
  );
};

const ImagePlaceholder = ({ imageUrl, title, theme }) => {
  const [imgError, setImgError] = useState(false);

  const getImageUrl = (picName) => {
    if (!picName || picName.trim() === "" || picName === "NULL" || picName === "null") return null;
    if (picName.startsWith('http')) return picName;
    let filename = picName;
    if (filename.includes('/')) filename = filename.split('/').pop();
    if (filename.includes('\\')) filename = filename.split('\\').pop();
    return `${serverURL}/uploadnew/upload/${filename}`;
  };

  const imgUrl = imageUrl && !imgError ? getImageUrl(imageUrl) : null;

  return (
    <div
      style={{
        width: "50px",
        height: "50px",
        borderRadius: "10px",
        background: `${theme.primary}15`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "14px",
        color: theme.primary,
        border: `1px solid ${theme.border}`,
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      {imgUrl ? (
        <img
          src={imgUrl}
          alt={title}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          onError={() => setImgError(true)}
        />
      ) : (
        "🖼️"
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────
const Services = () => {
  const { theme } = useContext(ThemeContext); // ← Theme Context
  
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const itemsPerPage = 10;

  // Fetch services from API
  const fetchServices = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getData("footercertificate/services");
      console.log("Services API Response:", response);

      let servicesData = [];
      if (response && response.status === true && response.data) {
        servicesData = response.data;
      } else if (Array.isArray(response)) {
        servicesData = response;
      } else if (response?.data && Array.isArray(response.data)) {
        servicesData = response.data;
      }

      setServices(servicesData);
    } catch (err) {
      console.error("Error fetching services:", err);
      setError(err.message || "Failed to fetch services");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  // Filter services
  const filteredServices = services.filter(service =>
    service.title?.toLowerCase().includes(search.toLowerCase()) ||
    service.description?.toLowerCase().includes(search.toLowerCase())
  );

  // Pagination
  const totalPages = Math.ceil(filteredServices.length / itemsPerPage);
  const paginatedServices = filteredServices.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Toggle status
  const toggleStatus = async (service) => {
    const newStatus = service.status === "1" || service.status === 1 ? "0" : "1";
    setActionLoading(true);
    try {
      const formData = new FormData();
      formData.append("id", service.id);
      formData.append("status", newStatus);
      
      const response = await postData("footercertificate/update_service", formData, "multipart/form-data");
      if (response && response.status === true) {
        fetchServices();
      } else {
        alert(response?.message || "Failed to update status");
      }
    } catch (error) {
      alert("Failed to update status: " + error.message);
    } finally {
      setActionLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this service?")) return;
    setActionLoading(true);
    try {
      const formData = new FormData();
      formData.append("id", id);
      
      const response = await postData("footercertificate/delete_service", formData, "multipart/form-data");
      if (response && response.status === true) {
        fetchServices();
      } else {
        alert(response?.message || "Failed to delete service");
      }
    } catch (error) {
      alert("Failed to delete service: " + error.message);
    } finally {
      setActionLoading(false);
    }
  };

  const handleEdit = (service) => {
    setEditingService(service);
    setIsDialogOpen(true);
  };

  const handleView = (service) => {
    alert(`📋 Service Details\n\nTitle: ${service.title}\n\nDescription: ${service.description || "—"}\n\nButton: ${service.button_name || "—"}\nLink: ${service.button_link || "—"}`);
  };

  const handleAddService = () => {
    setEditingService(null);
    setIsDialogOpen(true);
  };

  const handleSaveService = async (formData, existingService) => {
    setActionLoading(true);
    try {
      let response;
      
      if (existingService) {
        response = await postData("footercertificate/update_service", formData, "multipart/form-data");
      } else {
        response = await postData("footercertificate/create_service", formData, "multipart/form-data");
      }
      
      console.log("Save response:", response);
      
      if (response && response.status === true) {
        fetchServices();
        setIsDialogOpen(false);
        setEditingService(null);
        alert(existingService ? "✅ Service updated successfully!" : "✅ Service added successfully!");
      } else {
        alert(response?.message || "Failed to save service");
      }
    } catch (error) {
      console.error("Save error:", error);
      alert("Failed to save service: " + error.message);
    } finally {
      setActionLoading(false);
    }
  };

  const styles = {
    container: {
      background: "transparent",
      fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
      padding: "20px 24px",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "24px",
      flexWrap: "wrap",
      gap: "16px",
    },
    searchWrapper: {
      position: "relative",
      flex: 1,
      maxWidth: "400px",
      minWidth: "250px",
    },
    searchInput: {
      width: "100%",
      padding: "10px 12px 10px 38px",
      background: theme.surface,
      border: `1px solid ${theme.border}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: theme.textPrimary,
      outline: "none",
      transition: "all 0.2s ease",
      boxSizing: "border-box",
    },
    addBtn: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "10px 20px",
      background: theme.primary,
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: 600,
      cursor: "pointer",
      boxShadow: `0 4px 12px ${theme.primary}40`,
      transition: "all 0.2s ease",
    },
    refreshBtn: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "10px 16px",
      background: theme.surfaceLighter,
      color: theme.textSecondary,
      border: `1px solid ${theme.border}`,
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: 500,
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
    tableWrapper: {
      background: theme.surface,
      border: `1px solid ${theme.border}`,
      borderRadius: "16px",
      overflow: "hidden",
      boxShadow: `0 4px 12px ${theme.primary}08`,
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "900px",
    },
    th: {
      padding: "14px 16px",
      textAlign: "left",
      fontSize: "11px",
      fontWeight: 700,
      color: theme.primary,
      borderBottom: `1px solid ${theme.border}`,
      background: theme.surfaceLighter,
      whiteSpace: "nowrap",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    td: {
      padding: "14px 16px",
      fontSize: "13px",
      color: theme.textPrimary,
      borderBottom: `1px solid ${theme.border}`,
    },
    actions: {
      display: "flex",
      gap: "6px",
    },
    titleCell: {
      fontWeight: 700,
      color: theme.textPrimary,
      maxWidth: "200px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    descriptionCell: {
      maxWidth: "300px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: theme.textSecondary,
      fontSize: "12px",
    },
    buttonBadge: {
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      padding: "4px 10px",
      borderRadius: "8px",
      fontSize: "11px",
      fontWeight: 600,
      background: `${theme.primary}1a`,
      color: theme.primary,
    },
    footer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "14px 20px",
      borderTop: `1px solid ${theme.border}`,
      background: theme.surfaceLighter,
      flexWrap: "wrap",
      gap: "12px",
    },
    pageInfo: {
      fontSize: "12px",
      color: theme.textSecondary,
    },
    pagination: {
      display: "flex",
      gap: "6px",
    },
    emptyState: {
      padding: "60px",
      textAlign: "center",
    },
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
      
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.searchWrapper}>
          <span
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: theme.primary,
              display: "flex",
              alignItems: "center",
            }}
          >
            <SearchIcon />
          </span>
          <input
            type="text"
            style={styles.searchInput}
            placeholder="Search services by title or description..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = theme.primary;
              e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = theme.border;
              e.currentTarget.style.boxShadow = "none";
            }}
          />
          {search && (
            <button
              onClick={() => { setSearch(""); setCurrentPage(1); }}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: theme.textMuted,
                padding: "4px",
                display: "flex",
              }}
            >
              <XIcon />
            </button>
          )}
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            style={styles.refreshBtn}
            onClick={fetchServices}
            disabled={loading}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = theme.surfaceHover || theme.surface;
              e.currentTarget.style.color = theme.primary;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = theme.surfaceLighter;
              e.currentTarget.style.color = theme.textSecondary;
            }}
          >
            <RefreshIcon /> Refresh
          </button>
          <button
            style={styles.addBtn}
            onClick={handleAddService}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow = `0 6px 16px ${theme.primary}60`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}40`;
            }}
          >
            <PlusIcon /> Add Service
          </button>
        </div>
      </div>

      {/* Services Table */}
      <div style={styles.tableWrapper}>
        <div style={{ overflowX: "auto" }}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>ID</th>
                <th style={styles.th}>Image</th>
                <th style={styles.th}>Title</th>
                <th style={styles.th}>Description</th>
                <th style={styles.th}>Button</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={7}>
                    <div style={{ padding: "60px", textAlign: "center" }}>
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          border: `3px solid ${theme.border}`,
                          borderTopColor: theme.primary,
                          borderRadius: "50%",
                          margin: "0 auto 16px",
                          animation: "spin 0.8s linear infinite",
                        }}
                      />
                      <p style={{ color: theme.textMuted, fontSize: "14px", margin: 0 }}>
                        Loading services...
                      </p>
                    </div>
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan={7}>
                    <div style={{ padding: "60px", textAlign: "center" }}>
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                          background: `${theme.error || theme.danger}15`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 16px",
                          color: theme.error || theme.danger,
                          fontSize: "24px",
                        }}
                      >
                        ⚠️
                      </div>
                      <h3 style={{ color: theme.textPrimary, marginBottom: "8px", fontSize: "16px" }}>
                        Error Loading Services
                      </h3>
                      <p style={{ color: theme.textMuted, fontSize: "13px", marginBottom: "16px" }}>
                        {error}
                      </p>
                      <button
                        onClick={fetchServices}
                        style={{
                          padding: "8px 20px",
                          borderRadius: "8px",
                          border: "none",
                          background: theme.primary,
                          color: "#fff",
                          cursor: "pointer",
                          fontWeight: 600,
                          boxShadow: `0 4px 12px ${theme.primary}40`,
                        }}
                      >
                        Retry
                      </button>
                    </div>
                  </td>
                </tr>
              ) : paginatedServices.length === 0 ? (
                <tr>
                  <td colSpan={7}>
                    <div style={styles.emptyState}>
                      <div
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "50%",
                          background: `${theme.primary}15`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 16px",
                          color: theme.primary,
                        }}
                      >
                        <ServiceIcon />
                      </div>
                      <h3 style={{ color: theme.textPrimary, marginBottom: "8px", fontSize: "16px", fontWeight: 600 }}>
                        {search ? "No Matching Services" : "No Services Found"}
                      </h3>
                      <p style={{ color: theme.textMuted, fontSize: "13px", margin: 0 }}>
                        {search ? "Try a different search term" : "Create your first service to get started"}
                      </p>
                    </div>
                  </td>
                </tr>
              ) : (
                paginatedServices.map((service) => (
                  <tr
                    key={service.id}
                    style={{ transition: "background 0.15s ease" }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = theme.surfaceHover || theme.surfaceLighter)}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                  >
                    <td style={{ ...styles.td, color: theme.primary, fontFamily: "monospace", fontWeight: 700 }}>
                      #{service.id}
                    </td>
                    <td style={styles.td}>
                      <ImagePlaceholder imageUrl={service.pic} title={service.title} theme={theme} />
                    </td>
                    <td style={{ ...styles.td, ...styles.titleCell }} title={service.title}>
                      {service.title}
                    </td>
                    <td style={{ ...styles.td, ...styles.descriptionCell }} title={service.description}>
                      {service.description || "—"}
                    </td>
                    <td style={styles.td}>
                      {service.button_name ? (
                        <div>
                          <span style={styles.buttonBadge}>{service.button_name}</span>
                          {service.button_link && (
                            <div
                              style={{
                                fontSize: "10px",
                                color: theme.textMuted,
                                marginTop: "4px",
                                fontFamily: "monospace",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <LinkIcon /> {service.button_link}
                            </div>
                          )}
                        </div>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td style={styles.td}>
                      <StatusBadge status={service.status} theme={theme} />
                    </td>
                    <td style={styles.td}>
                      <div style={styles.actions}>
                        <button
                          style={{
                            background: `${theme.primary}15`,
                            border: `1px solid ${theme.primary}30`,
                            cursor: actionLoading ? "not-allowed" : "pointer",
                            padding: "6px 8px",
                            color: theme.primary,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "6px",
                            transition: "all 0.2s ease",
                            opacity: actionLoading ? 0.5 : 1,
                          }}
                          onClick={() => handleView(service)}
                          title="View"
                          disabled={actionLoading}
                          onMouseEnter={(e) => (e.currentTarget.style.background = `${theme.primary}25`)}
                          onMouseLeave={(e) => (e.currentTarget.style.background = `${theme.primary}15`)}
                        >
                          <EyeIcon />
                        </button>
                        <button
                          style={{
                            background: `${theme.warning}15`,
                            border: `1px solid ${theme.warning}30`,
                            cursor: actionLoading ? "not-allowed" : "pointer",
                            padding: "6px 8px",
                            color: theme.warning,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "6px",
                            transition: "all 0.2s ease",
                            opacity: actionLoading ? 0.5 : 1,
                          }}
                          onClick={() => handleEdit(service)}
                          title="Edit"
                          disabled={actionLoading}
                          onMouseEnter={(e) => (e.currentTarget.style.background = `${theme.warning}25`)}
                          onMouseLeave={(e) => (e.currentTarget.style.background = `${theme.warning}15`)}
                        >
                          <EditIcon />
                        </button>
                        <button
                          style={{
                            background: (service.status === "1" || service.status === 1) ? `${theme.success}15` : `${theme.textMuted}15`,
                            border: `1px solid ${(service.status === "1" || service.status === 1) ? theme.success : theme.textMuted}30`,
                            cursor: actionLoading ? "not-allowed" : "pointer",
                            padding: "6px 8px",
                            color: (service.status === "1" || service.status === 1) ? theme.success : theme.textMuted,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "6px",
                            transition: "all 0.2s ease",
                            opacity: actionLoading ? 0.5 : 1,
                          }}
                          onClick={() => toggleStatus(service)}
                          title={service.status === "1" || service.status === 1 ? "Hide" : "Show"}
                          disabled={actionLoading}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = (service.status === "1" || service.status === 1) ? `${theme.success}25` : `${theme.textMuted}25`;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = (service.status === "1" || service.status === 1) ? `${theme.success}15` : `${theme.textMuted}15`;
                          }}
                        >
                          {service.status === "1" || service.status === 1 ? <HideIcon /> : <ShowIcon />}
                        </button>
                        <button
                          style={{
                            background: `${theme.error || theme.danger}15`,
                            border: `1px solid ${theme.error || theme.danger}30`,
                            cursor: actionLoading ? "not-allowed" : "pointer",
                            padding: "6px 8px",
                            color: theme.error || theme.danger,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "6px",
                            transition: "all 0.2s ease",
                            opacity: actionLoading ? 0.5 : 1,
                          }}
                          onClick={() => handleDelete(service.id)}
                          title="Delete"
                          disabled={actionLoading}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = theme.error || theme.danger;
                            e.currentTarget.style.color = "#fff";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = `${theme.error || theme.danger}15`;
                            e.currentTarget.style.color = theme.error || theme.danger;
                          }}
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Footer with Pagination */}
        {!loading && filteredServices.length > 0 && (
          <div style={styles.footer}>
            <div style={styles.pageInfo}>
              Showing <strong style={{ color: theme.textPrimary }}>{Math.min((currentPage - 1) * itemsPerPage + 1, filteredServices.length)}</strong> to <strong style={{ color: theme.textPrimary }}>{Math.min(currentPage * itemsPerPage, filteredServices.length)}</strong> of <strong style={{ color: theme.textPrimary }}>{filteredServices.length}</strong> services
            </div>
            <div style={styles.pagination}>
              <button
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "6px",
                  border: `1px solid ${theme.border}`,
                  background: theme.surface,
                  color: currentPage === 1 ? theme.textMuted : theme.textPrimary,
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: currentPage === 1 ? 0.5 : 1,
                  transition: "all 0.2s ease",
                }}
                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                disabled={currentPage === 1}
              >
                ‹
              </button>
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                let pageNum;
                if (totalPages <= 5) pageNum = i + 1;
                else if (currentPage <= 3) pageNum = i + 1;
                else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
                else pageNum = currentPage - 2 + i;
                return pageNum <= totalPages && (
                  <button
                    key={pageNum}
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "6px",
                      border: currentPage === pageNum ? `1px solid ${theme.primary}` : `1px solid ${theme.border}`,
                      background: currentPage === pageNum ? theme.primary : theme.surface,
                      color: currentPage === pageNum ? "#fff" : theme.textSecondary,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: currentPage === pageNum ? 700 : 500,
                      fontSize: "12px",
                      transition: "all 0.2s ease",
                    }}
                    onClick={() => setCurrentPage(pageNum)}
                  >
                    {pageNum}
                  </button>
                );
              })}
              <button
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "6px",
                  border: `1px solid ${theme.border}`,
                  background: theme.surface,
                  color: currentPage === totalPages ? theme.textMuted : theme.textPrimary,
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: currentPage === totalPages ? 0.5 : 1,
                  transition: "all 0.2s ease",
                }}
                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                disabled={currentPage === totalPages}
              >
                ›
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Add/Edit Service Dialog */}
      {isDialogOpen && (
        <AddServiceDialog
          onClose={() => {
            setIsDialogOpen(false);
            setEditingService(null);
          }}
          onSave={handleSaveService}
          editingService={editingService}
          theme={theme}
        />
      )}
    </div>
  );
};

export default Services;